/* eslint-disable */
import React, { useLayoutEffect } from "react";
import { CancerBrochure, ManhattanLifeLogo } from "../../../../../assets";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";
import VEBCancerImage from "../../../../../assets/VEBPlanImages/VEBCancerImage.avif";

import "./cancer.scss";

const CancerPlan: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<div className="cancer-plan-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">Cancer Plan</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={ManhattanLifeLogo} alt="" />
					</div>
					<div className="plan-description">
						<span>
							When you or a loved one is diagnosed with cancer, the financial burden can be overwhelming.
							While primary health insurance is there to cover the medical bills, many patients face
							challenges due to time away from work and expenses that may not be covered by other
							insurance.
						</span>

						<h3>Stay focused on getting well</h3>
						<span>
							A ManhattanLife Cancer Insurance policy gives you an extra layer of financial security
							during these tough times—providing benefits that you can use to help keep the bills paid and
							protect your savings. That way, your focus can be on getting better.
						</span>
					</div>
				</div>
				<div className="right-section">
					<img src={VEBCancerImage} alt="VEBCancerImage" />
				</div>
			</div>
			<h3 className="sub-heading-title">Plan Brochure</h3>

			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={CancerBrochure} />
			</div>
		</div>
	);
};

export default CancerPlan;
